"use strict";

import angular from "angular";

/**
 * Se a navegação trocou de TELA, e não só a query string.
 *
 * As telas com filtro rápido na URL (`?aba=`, com `reloadOnSearch: false`) mudam a query a cada
 * troca de aba sem sair da página. Zerar a busca nesse caso apagava o texto do campo enquanto a
 * tela seguia filtrando por ele — a lista dizia uma coisa e o campo, outra.
 */
export const isSamePage = (next = "", current = "") =>
    String(next).split(/[?#]/)[0] === String(current).split(/[?#]/)[0];

export class TableSearchService {
    searchText = "";
    opened = false;

    constructor($rootScope) {
        $rootScope.$on("$locationChangeSuccess", (event, next, current) => {
            if (!isSamePage(next, current)) this.reset();
        });
    }

    set(searchText = "") {
        this.searchText = searchText;
        if (searchText) this.opened = true;
    }

    get() {
        return this.searchText;
    }

    setOpened(opened = false) {
        this.opened = opened;
    }

    isOpened() {
        return this.opened;
    }

    reset() {
        this.searchText = "";
        this.opened = false;
    }
}

TableSearchService.$inject = ["$rootScope"];

angular.module("nucont.shared").service("TableSearchService", TableSearchService);
